import React from 'react'
import clsx from 'clsx'

import { AvatarWrapper } from './wrapper'
import { CommonProps } from './types/common'
import { sizeClassnames, shapeClassnames } from './utils/common'

export interface TextAvatarProps extends CommonProps {
  text: string
}

export const TextAvatar = React.forwardRef<any, TextAvatarProps>(
  (props, ref: any) => {
    const {
      text,
      size = 'md',
      shape = 'circle',
      showNotification = false,
      notificationStatus = 'default',
      notificationPosition = 'top-right',
      className,
    } = props

    const textSizeClassnames = {
      xs: 'text-sm',
      sm: 'text-md',
      md: 'text-lg',
      lg: 'text-xl',
      xl: 'text-2xl',
    }

    return (
      <AvatarWrapper
        ref={ref}
        rootClassName={clsx([
          'inline-flex',
          'items-center',
          'justify-center',
          'bg-gray-500',
          'relative',
          ...[shapeClassnames[shape]],
          ...[sizeClassnames[size].main],
          className,
        ])}
        size={size}
        shape={shape}
        showNotification={showNotification}
        notificationStatus={notificationStatus}
        notificationPosition={notificationPosition}
      >
        <span
          className={clsx(
            'font-medium leading-none text-white',
            textSizeClassnames[size]
          )}
        >
          {text}
        </span>
      </AvatarWrapper>
    )
  }
)
